module.exports = new __parcel__URL__("shop_brawler_bearz_image_v2.ce6bfd5e.png").toString();